import * as React from 'react';

import type {CoreEntityType, FilterObject} from 'nutshell-core/types';

import type {Flow} from 'flow-to-typescript-codemod';

import {ActionsDefault} from './actions-default';
import type {Props as ActionsDefaultOwnProps} from './actions-default';
import {BulkSyncButton} from './bulk-sync-button';
import {CreateLeadsButton} from './create-leads-button';

type ActionsDefaultProps = Flow.Diff<
    ActionsDefaultOwnProps,
    {
        entityType: CoreEntityType;
    }
>;

type Props = ActionsDefaultProps & {
    filters: FilterObject[];
    q: string;
    entityData: {
        string: {
            id: string;
            primaryName: string;
        };
    };
    massSelect: boolean;
    allItems: any[];
    selectedItems: string[];
    omittedItems: string[];
    handleSyncToWebfxSubmit: (arg1: 'contacts' | 'leads') => (...args: any) => any;
    canAccessCrm: boolean;
    selectedCount: number;
};

export function ActionsContact(props: Props) {
    const {
        handleSyncToWebfxSubmit,
        filters,
        q,
        allItems,
        entityData,
        massSelect,
        selectedCount,
        selectedItems,
        omittedItems,
        canAccessCrm,
        ...restProps
    } = props;

    return (
        <>
            {NutClientConfig.hasSyncContactsButton && (
                <BulkSyncButton
                    selectedCount={selectedCount}
                    onSubmit={handleSyncToWebfxSubmit('contacts')}
                    entityType={'contacts'}
                />
            )}
            {canAccessCrm && (
                <CreateLeadsButton
                    filters={filters}
                    q={q}
                    allItems={allItems}
                    isDisabled={selectedCount === 0}
                    entityData={entityData}
                    entityType={'contacts'}
                    massSelect={massSelect}
                    selectedCount={selectedCount}
                    selectedItems={selectedItems}
                    omittedItems={omittedItems}
                />
            )}
            <ActionsDefault
                {...restProps}
                entityType={'contacts'}
                filters={filters}
                massSelect={massSelect}
                selectedCount={selectedCount}
                selectedItems={selectedItems}
                allItems={allItems}
            />
        </>
    );
}
